import { render, staticRenderFns } from "./subscription_pricing.vue?vue&type=template&id=55323135&scoped=true&"
import script from "./subscription_pricing.vue?vue&type=script&lang=js&"
export * from "./subscription_pricing.vue?vue&type=script&lang=js&"
import style0 from "./subscription_pricing.vue?vue&type=style&index=0&id=55323135&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55323135",
  null
  
)

export default component.exports